import { FC } from 'react';

import Image from './image.svg';

export const LogoLarge: FC = () => <img src={Image} alt="large logo" />;
